var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('v-title',{attrs:{"title":"pro CRM SF test"}}),_c('section-banner'),_c('section-links'),_c('section-info'),_c('section-agent-s-f'),_c('section-functional'),_c('section-integration'),_c('section-team'),_c('section-partners')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }